/**
 * @desc 阶段批量处理(PO审批通过)
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: Array<defs.basics.TimelinessDashboardProcessPhaseRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/timelinessDashboard/batchProcessPhasePurchaseCreate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
